import { Pipe, PipeTransform } from '@angular/core';
import { formatBytes } from '@cigna/chcp/shared/util';

@Pipe({
  name: 'formatBytes',
})
export class FormatBytesPipe implements PipeTransform {
  transform(bytes: number): string {
    return formatBytes(bytes);
  }
}
